// extracted by mini-css-extract-plugin
export default {"container":"CarSold_container__I4nMn","box":"CarSold_box__oZ5lI","boxBtn":"CarSold_boxBtn__TKhnJ"};